import { useDeleteTransItem } from '../api';
import { useUpdateSessionCart } from '../useUpdateSessionCart';

export const useDeleteCartItem = (
	onComplete?: () => void
): ((id: string) => void) => {
	const updateSessionCart = useUpdateSessionCart(onComplete);
	const deleteTransItem = useDeleteTransItem(updateSessionCart);

	return deleteTransItem;
};
